// Generated by CoffeeScript 2.4.1
(function() {
  var JSON5, Promise, _, evokeDate, evokeJSON, flatten, getResolver, guessDataType, isArray, isBoolean, isDate, isNumber, isObject, isString, luxon, moment, parseBoolean, parseDate, parseJSON, parseNumber, parseString, parseTime, prettyPrint, typeShouldBe,
    indexOf = [].indexOf;

  _ = require('lodash');

  moment = require('moment');

  luxon = require('luxon');

  JSON5 = require('json5');

  Promise = require('bluebird');

  typeShouldBe = function(type) {
    return function(val) {
      return Object.prototype.toString.call(val) === type;
    };
  };

  flatten = function(arr) {
    return arr.reduce(function(flat, toFlatten) {
      if (typeShouldBe('[object Array]')(toFlatten)) {
        return flat.concat(flatten(toFlatten));
      }
      return flat.concat(toFlatten);
    }, []);
  };

  getResolver = function(isSynchronous) {
    if (isSynchronous) {
      return function(arg) {
        return arg;
      };
    } else {
      return Promise.resolve;
    }
  };

  isString = function(val) {
    return typeShouldBe('[object String]')(val);
  };

  isNumber = function(val) {
    return typeShouldBe('[object Number]')(val);
  };

  isBoolean = function(val) {
    return typeShouldBe('[object Boolean]')(val);
  };

  isObject = function(val) {
    return typeShouldBe('[object Object]')(val);
  };

  isArray = function(val) {
    return typeShouldBe('[object Array]')(val);
  };

  isDate = function(val) {
    return val instanceof Date || val instanceof moment || val instanceof luxon.DateTime;
  };

  guessDataType = function(value) {
    if (value == null) {
      throw new Error('When calling guessDataType value is undefined');
    }
    if (isString(value)) {
      return 'string';
    } else if (isNumber(value)) {
      return 'double';
    } else if (isBoolean(value)) {
      return 'boolean';
    } else if (isDate(value)) {
      return 'date';
    } else if (isObject(value)) {
      return 'json';
    } else {
      throw Error(`Unsupported dataType for value ${value}`);
    }
  };

  // Returns boolean
  parseBoolean = function(value) {
    var ref;
    if (isBoolean(value)) {
      return value;
    }
    if (isString(value)) {
      switch (value != null ? (ref = value.toLowerCase()) != null ? ref.trim() : void 0 : void 0) {
        case 'true':
          return true;
        case 'yes':
          return true;
        case '1':
          return true;
        case 'false':
          return false;
        case 'no':
          return false;
        case '0':
          return false;
      }
    }
    throw new Error(`Failed to parse value ${value} to boolean`);
  };

  // Returns string ISO representation
  parseDate = function(value, timeLibrary, forceUTC = false) {
    var date;
    date = void 0;
    if (isString(value)) {
      if (timeLibrary === 'native') {
        date = new Date(value);
      } else if (timeLibrary === 'moment') {
        if (forceUTC) {
          date = moment.utc(value);
        } else {
          date = moment(value);
        }
      } else if (timeLibrary === 'luxon') {
        if (forceUTC) {
          date = luxon.DateTime.fromSQL(value, {
            zone: 'utc' // this route is the most forgiving # , locale: 'utc'
          });
          if (!date.isValid) { // , locale: 'utc'
            date = luxon.DateTime.fromISO(value, {
              zone: 'utc'
            });
          }
        } else {
          date = luxon.DateTime.fromSQL(value); // this route is the most forgiving # , locale: 'utc'
          if (!date.isValid) { // , locale: 'utc'
            date = luxon.DateTime.fromISO(value);
          }
        }
      } else {
        throw new Error('Unsupported time library configured');
      }
    }
    if (isNumber(value)) {
      if (timeLibrary === 'native') {
        date = new Date(value);
      } else if (timeLibrary === 'moment') {
        date = moment.utc(value);
      } else if (timeLibrary === 'luxon') {
        date = luxon.DateTime.fromMillis(value); // , { locale: 'utc' }
      }
    }
    if (date == null) {
      date = value;
    }
    if (date instanceof Date) {
      if (isNaN(date)) {
        throw new Error('Invalid date');
      }
      return date.toJSON();
    } else if (date instanceof moment) {
      if (!date.isValid()) {
        throw new Error('Invalid date');
      }
      return moment.utc(date).toJSON();
    } else if (date instanceof luxon.DateTime) {
      date = date.toUTC();
      if (!date.isValid) {
        throw new Error(date.invalidExplanation);
      }
      return date.toISO();
    } else {
      throw new Error('Date value is not of type [string, Date, moment or luxon.DateTime]');
    }
  };

  // Returns string
  parseTime = function(value) {
    if (isString(value)) {
      return value;
    } else {
      throw new Error(`Could not parse ${value} as time`);
    }
  };

  // Returns number
  parseNumber = function(value) {
    var parsed;
    parsed = void 0;
    if (isNumber(value)) {
      parsed = value;
    } else {
      parsed = parseFloat(value);
    }
    if (isNaN(parsed)) {
      throw new Error(`Could not parse ${value} to number`);
    }
    return parsed;
  };

  // Returns string
  parseString = function(value) {
    if (isString(value)) {
      return value;
    } else if (value instanceof Date || value instanceof moment || value instanceof luxon.DateTime) {
      return parseDate(value);
    } else if (isArray(value) || isObject(value)) {
      return parseJSON(value);
    } else if (isNumber(value)) {
      return value.toString();
    } else if (isBoolean(value)) {
      return value.toString();
    } else {
      throw new Error(`Failed to parse value ${value} to string`);
    }
  };

  // Returns string
  parseJSON = function(value, json5format = false) {
    var e;
    if (isObject(value) || isArray(value)) {
      try {
        return JSON.stringify(value);
      } catch (error) {
        e = error;
        throw new Error('Attribute value contains cirular reference');
      }
    } else if (isString(value) && value.length !== 0) {
      if (json5format) {
        try {
          JSON5.parse(value);
        } catch (error) {
          e = error;
          throw new Error('Could not parse string value to JSON5 object');
        }
      } else {
        try {
          JSON.parse(value);
        } catch (error) {
          e = error;
          throw new Error('Could not parse string value to JSON object');
        }
      }
      return value;
    } else {
      throw new Error(`Failed to parse value ${value} to JSON object`);
    }
  };

  // Returns object representation
  evokeDate = function(value, timeLibrary) {
    if (!isString(value)) {
      throw Error('Can only evoke date from string');
    }
    if (timeLibrary === 'native') {
      return new Date(value);
    } else if (timeLibrary === 'moment') {
      return moment.utc(value);
    } else if (timeLibrary === 'luxon') {
      return luxon.DateTime.fromISO(value, {
        zone: 'utc'
      });
    } else {
      throw new Error('Unsupported time library configured');
    }
  };

  evokeJSON = function(value, json5format = false) {
    if (json5format) {
      return JSON5.parse(value);
    } else {
      return JSON.parse(value);
    }
  };

  prettyPrint = function(node, opts = {}) {
    var addLine, eol, fill, guides, indent, line, lines, maxLength, newLine, nodeToTree, traverse, tree;
    // Default values
    if (opts.forward == null) {
      opts.forward = true;
    }
    // Create a tree
    nodeToTree = function(n, trail = []) {
      var attribute, formatted, fromNode, j, k, key, keys, l, len, len1, len2, len3, len4, len5, m, o, p, record, ref, ref1, ref2, ref3, ref4, relation, richKey, toNode, tree;
      tree = {};
      trail.push(n.id());
      if (opts.forward) {
        keys = _.keys(n.relations());
        keys = keys.sort();
        for (j = 0, len = keys.length; j < len; j++) {
          key = keys[j];
          relation = n.relations()[key];
          ref = relation.allRecords();
          for (k = 0, len1 = ref.length; k < len1; k++) {
            record = ref[k];
            richKey = opts.includeRelIds ? `${key}[${record.relNode.id()}]` : key;
            if (tree[richKey] == null) {
              tree[richKey] = [];
            }
            toNode = record.toNode;
            if (ref1 = toNode.id(), indexOf.call(trail, ref1) >= 0) {
              tree[richKey].push(toNode.id() + ' @');
            } else {
              tree[richKey].push(nodeToTree(toNode, trail));
            }
          }
        }
      }
      if (opts.backward) {
        keys = _.keys(n._relationsIn);
        keys = keys.sort();
        for (l = 0, len2 = keys.length; l < len2; l++) {
          key = keys[l];
          relation = n._relationsIn[key];
          ref2 = relation.allRecords();
          for (m = 0, len3 = ref2.length; m < len3; m++) {
            record = ref2[m];
            richKey = opts.includeRelIds ? `^${key}[${record.relNode.id()}]` : `^${key}`;
            if (tree[richKey] == null) {
              tree[richKey] = [];
            }
            fromNode = record.fromNode;
            if (ref3 = fromNode.id(), indexOf.call(trail, ref3) >= 0) {
              tree[richKey].push(fromNode.id() + ' @');
            } else {
              tree[richKey].push(nodeToTree(fromNode, trail));
            }
          }
        }
      }
      if (opts.includeAttributes) {
        keys = _.keys(n._attributes);
        keys = keys.sort();
        for (o = 0, len4 = keys.length; o < len4; o++) {
          key = keys[o];
          attribute = n._attributes[key];
          ref4 = attribute.allRecords();
          for (p = 0, len5 = ref4.length; p < len5; p++) {
            record = ref4[p];
            formatted = _.isObject(record.value) ? JSON.stringify(record.value) : `"${record.value}"`;
            if (tree[key] == null) {
              tree[key] = [];
            }
            tree[key].push(`${formatted}^^${record.dataType}`);
          }
        }
      }
      return {
        [n.id()]: tree
      };
    };
    tree = nodeToTree(node);
    line = '';
    lines = [];
    guides = []; // num of spaces for position of vertical guide line
    eol = []; // same num of elements in guides, false by default, true if eol
    
    // Create ascii from tree
    fill = function(ch, nr) {
      return new Array(nr).join(ch);
    };
    indent = function() {
      var index, j, len, nr, results;
      results = [];
      for (index = j = 0, len = guides.length; j < len; index = ++j) {
        nr = guides[index];
        line += !eol[index] ? '│' : ' ';
        results.push(line += fill(' ', nr));
      }
      return results;
    };
    maxLength = function(keys) {
      var j, key, len, length;
      length = 0;
      for (j = 0, len = keys.length; j < len; j++) {
        key = keys[j];
        length = Math.max(length, key.length);
      }
      return length;
    };
    newLine = function() {
      lines.push(line);
      return line = '';
    };
    traverse = function(subtree) {
      var arr, i, id, item, j, key, keyLength, last, len, rest, results, todo, todos;
      results = [];
      for (id in subtree) {
        rest = subtree[id];
        line += id;
        newLine();
        keyLength = maxLength((function() {
          var results1;
          results1 = [];
          for (key in rest) {
            arr = rest[key];
            results1.push(key);
          }
          return results1;
        })());
        todos = [];
        for (key in rest) {
          arr = rest[key];
          for (j = 0, len = arr.length; j < len; j++) {
            item = arr[j];
            todos.push({key, item});
          }
        }
        results.push((function() {
          var k, ref, results1;
          results1 = [];
          for (i = k = 0, ref = todos.length; (0 <= ref ? k < ref : k > ref); i = 0 <= ref ? ++k : --k) {
            todo = todos[i];
            last = i === todos.length - 1;
            addLine(todo.key, keyLength, last);
            if (typeof todo.item === 'string') {
              line += todo.item;
              results1.push(newLine());
            } else {
              guides.push(keyLength + 7);
              eol.push(last);
              traverse(todo.item);
              eol.pop();
              results1.push(guides.pop());
            }
          }
          return results1;
        })());
      }
      return results;
    };
    addLine = function(key, keyLength, last) {
      var padding;
      indent();
      padding = keyLength - key.length + 1;
      line += !last ? '├─(' : '└─(';
      line += key;
      line += ')';
      line += fill('─', padding);
      if (key.startsWith('^')) {
        return line += '── ';
      } else {
        return line += '─> ';
      }
    };
    traverse(tree);
    // '─'
    // '┬'
    // '├'
    // '│'
    // '└'
    return lines.join('\n');
  };

  module.exports = {evokeDate, evokeJSON, flatten, getResolver, guessDataType, isArray, isBoolean, isDate, isNumber, isObject, isString, parseBoolean, parseDate, parseJSON, parseNumber, parseString, parseTime, prettyPrint};

}).call(this);
